"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropDownOption = void 0;
const Colors_1 = require("../../Colors");
exports.DropDownOption = {
    titleIcon: {
        show: false,
        name: 'default',
        size: 30,
        color: Colors_1.Colors.grey,
    },
    itemIcon: {
        show: false,
        name: 'default',
        size: 30,
        color: Colors_1.Colors.w_grey,
        focus: Colors_1.Colors.grey,
    },
    downIcon: {
        show: true,
        name: 'arrow',
        size: 20,
        color: Colors_1.Colors.grey,
    },
};
